import { Routes } from '@angular/router';

export const blogRoutes: Routes = [
    {
        path: $localize`:@@pathBlog:blog`,
        loadComponent: () => import('src/app/blog/views/blog/blog.component').then(module => module.BlogComponent),
        data: {
            path: 'blog'
        },
        children: [
            {
                path: '',
                loadComponent: () => import('src/app/blog/views/blog/blog-list/blog-list.component').then(module => module.BlogListComponent),
                data: {
                    path: 'blog.list'
                }
            },
            {
                path: ':page',
                loadComponent: () => import('src/app/blog/views/blog/blog-list/blog-list.component').then(module => module.BlogListComponent),
                data: {
                    path: 'blog.list'
                }
            },
            {
                path: $localize`:@@pathBlogPost:wpis` + '/:url',
                loadComponent: () => import('src/app/blog/views/blog/blog-post/blog-post.component').then(module => module.BlogPostComponent),
                data: {
                    path: 'blog.post'
                }
            },
            {
                path: '**',
                redirectTo: ''
            },
        ]
    },
];
